module.exports = __webpack_public_path__ + "static/media/envelope-open-dollar.99e40697.svg";